
const accountPayable        = require ('./clientActivity-report-account-payable')

export function start(detail){  //console.log('goku-dt 5>', detail)
      obj[detail.reportType].start(detail)

}/**/

const obj = {
   accountPayable:     { start: (detail)=>{  accountPayable.start(detail)  }},
}


//Account Receivable 